import EditAddress from '../components/customer/customerDetail/EditAddress';

const EditAddressPage = () => <EditAddress />;

export default EditAddressPage;
